import React, { useState, useEffect } from "react";
import { Table, Image, message } from "antd";
import { YHModal } from "@/components/YHModal";
import { usePayableModel } from "../payableModel";
import { TablePaginationConfig } from "antd/lib/table";
import { YhBox } from "@/components/YhBox";
import { transPgToPagination } from "@/model/globalModel";
import { ISearchPage } from "@/types/AppTypes";
import { salesService } from "@/views/sales/salesService";
import { getBaseRequestUrl, getToken } from '@/utils/constants';
import { publicService } from '@/views/public/publicService';
import { convertRes2Blob } from '@/utils/exportFile';
import moment from "moment";
import { formatNum } from "@/utils/utils";

//
export const DetailedDiolog = () => {
    const { detailedDialog: { visible, row }, setDetailedDialog } = usePayableModel(({ detailedDialog }) => [detailedDialog])
    const [dataSource, setDataSource] = useState<any[]>([]);
    const initPgCfg: TablePaginationConfig = { pageSize: 10, current: 1 }
    const [pgCfg, setPgCfg] = useState<TablePaginationConfig>(initPgCfg);
    const [loading, setLoadding] = useState<boolean>(false);

    useEffect(() => {
        console.log(row)
        visible && loadData()
    }, [visible])

    const onCancel = () => {
        setDetailedDialog({ visible: false });
    };

    let loadData = async (page?: ISearchPage) => {
        setLoadding(true);
        try {
            const searchParams = {
                code: row?.saleCode ? row?.shipmentCode ?? row?.saleCode ?? "" : row?.code ?? "",
                ioFlag: 1,
                page: {
                    pageSize: page?.pageSize ?? pgCfg.pageSize,
                    pageNum: (page?.current || page?.pageNum) ?? pgCfg.current
                }
            }
            let { retData } = await salesService.receiptPage(searchParams);
            const { records, ...pg } = retData;
            setPgCfg(transPgToPagination(pg));
            setDataSource(records);
            setLoadding(false);
        } catch (err) { setLoadding(false) }
    }

    //下载文件
    const downloadFile = async (fileId?: string, fileName?: string) => {
        if (!fileId) return message.warning("文件异常，无法下载查看");
        //pdf开网页预览
        if (fileId.indexOf(".pdf") >= 0) {
            window.open(`${getBaseRequestUrl()}/fsrv/fetch/${fileId}?Authorization=${getToken()}`)
            return;
        }
        try {
            let result = await publicService.downloadFile(fileId);
            convertRes2Blob(result, fileName);
        } catch (error) {
            console.error(error)
        }
    }

    const column: any = [
        {
            title: '序号',
            width: 60,
            align: "center",
            render: (t: any, r: any, i: number) => <>{i + 1}</>
        }, {
            title: '付款日期',
            align: "center",
            dataIndex: 'settleTime',
            render: (t: moment.MomentInput) => t ? moment(t).format('YYYY-MM-DD') : '',
        }, {
            title: '付款金额',
            align: "center",
            dataIndex: 'settlePrice',
            render: (text: any, record: any) => formatNum(text),
        },
        {
            title: '附件',
            width: 140,
            dataIndex: 'appendixList',
            align: "center",
            render: (fileList: any, record: any, index: number) => {
                return <>
                    {(fileList ?? []).map((file: any, index: number) => {
                        if ((file.md5.indexOf(".png") > -1 || file.md5.indexOf(".jpg") > -1 || file.md5.indexOf(".gif") > -1 || file.md5.indexOf(".jpeg") > -1)) {
                            return <div key={index}>
                                <Image src={`${getBaseRequestUrl()}/fsrv/fetch/${file.md5}?Authorization=${getToken()}`} style={{ width: "40px", height: "40px", marginRight: "10px" }} />
                                <span style={{ color: "blue", cursor: "pointer" }} onClick={() => downloadFile(file.md5, file.name)}>{file.name}</span>
                            </div>
                        } else {
                            return <div style={{ color: "blue", cursor: "pointer" }} onClick={() => downloadFile(file.md5, file.name)} key={index}>{file.name}</div>
                        }
                    })}
                </>
            }
        }
    ];


    return <YHModal
        visible={visible}
        okText="确认"
        onOk={onCancel}
        onCancel={onCancel}
        title="付款明细"
        width={600}
        bodyHeight={600}
        showFooter={true}
    >
        <YhBox title="" style={{ marginBottom: "5px", paddingBottom: 0 }}>
            <Table
                loading={loading}
                rowKey={record => record.id}
                columns={column}
                dataSource={dataSource}
                pagination={{
                    ...pgCfg,
                    position: ["bottomCenter"],
                    onChange: (pageNum, pageSize) => {
                        loadData({ pageNum, pageSize })
                    }
                }}
                scroll={{ x: 'max-content' }}
            />
        </YhBox>
    </YHModal>
}